import PropTypes from "prop-types";
import React from "react";
import { List, Divider } from "@mui/material";
import TodoItem from "././TodoItem";
export default function TodoList(props) {
  const { todoList } = props;
  return (
    <List>
      {todoList.map((todoItem, index) => (
        <React.Fragment key={index}>
          {todoList.length === 1 && <Divider component="li" />}
          <TodoItem {...todoItem} />
          <Divider component="li" />
        </React.Fragment>
      ))}
    </List>
  );
}

TodoList.propTypes = {
  todoList: PropTypes.array
};
